import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserRole } from '../models/user.model';

// Использование в роутах:
//   canActivate: [roleGuard(['admin', 'superadmin'])]
export const roleGuard = (allowedRoles: UserRole[]): CanActivateFn => {
    return () => {
        const auth = inject(AuthService);
        const router = inject(Router);

        const user = auth.currentUser();

        if (user && user.role && allowedRoles.includes(user.role)) {
            return true;
        }

        return router.createUrlTree(['/profile/settings']);
    };
};